import request from "@/utils/request"

//添加站点切换服务器计划
export function AddSiteIpSPlan(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerSiteIpSPlan/AddSiteIpSPlan",
    method: "get",
    params
  })
}

//添加站点切换服务器计划
export function AddSiteIpSPlan_Pl(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerSiteIpSPlan/AddSiteIpSPlan_Pl",
    method: "post",
    data
  })
}
//删除设备切换服务器计划
export function delSiteIpsPlan(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerSiteIpSPlan/delSiteIpsPlan",
    method: "post",
    data
  })
}

// 获取站点切换服务器计划
export function GetSiteIpSPageList(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerSiteIpSPlan/GetSiteIpSPageList",
    method: "post",
    data
  })
}

// 获取站点切换服务器计划各状态下的数据统计
export function getSiteIpSStatisticsApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerSiteIpSPlan/GetSiteIpSStatistics",
    method: "post",
    data
  })
}

//批量删除设备切换服务器计划
export function batchDelSiteIpsPlan(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerSiteIpSPlan/delEBoxIpsPlanS",
    method: "post",
    data
  })
}

//清空筛选条件下的所有切换服务器计划
export function clearSiteIpsPlan(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerSiteIpSPlan/ClearSiteIpsPlan",
    method: "post",
    data
  })
}

//编辑切换计划状态及备注
export function updateIpsSite(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerSiteIpSPlan/UpdateIpsSite",
    method: "post",
    data
  })
}
